import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: "#439289",
        secondary: "#efe2d2",
        background: "#FFFFFF",
        black: "#000000",
        bg: "#e5e5e5"
      },
      light: {
        primary: "#439289",
        secondary: "#efe2d2",
        background: "#FFFFFF",
        black: "#000000",
        bg: "#e5e5e5"
      }
    }
  }
});
